import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import BackArrow from '../BackArrow';
import {
  Container,
  Info,
  List,
} from './styles';
import { RootState } from '../../store';
import { setCurrentClass, getClasses } from '../../store/Classes.store';
import ClassListItem from '../ClassesListItem';
import ClassesListSkeleton from '../ClassesListSkeleton';
import hiddenClassesBasic from './hiddenClassesBasic';

function ClassesList() {
  const [loading, setLoading] = useState<boolean>(true);
  const classes = useSelector((state: RootState) => state.classes.ClassList);
  const isBasic = useSelector((state: RootState) => state.auth.user.subscription_type) === 'BASIC';
  const { subscription } = useSelector((state: RootState) => state.subscription);
  const isSubscriptionAfterRuleDate = subscription ? (isBasic && new Date(subscription?.start_at) > new Date('2025-05-12')) : true;

  const dispatch = useDispatch<any>();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getClasses());
  }, []);

  useEffect(() => {
    if (classes?.length > 0) {
      setLoading(false);
    }
  }, [classes]);

  return (
    <Container>
      <BackArrow text="ORIENTAÇÕES EM VÍDEO AULAS" bigger backTo="/club" />
      <Info>
        Confira a seguir todas as nossas séries de vídeo aulas que vão
        orientar sua jornada de sucesso na corrida.
      </Info>
      {loading
        ? (
          <ClassesListSkeleton />
        )
        : (
          <>
            <List>
              {
                classes.map((item) => (
                  <ClassListItem
                    key={item.id}
                    isLocked={isSubscriptionAfterRuleDate && hiddenClassesBasic.includes(item.internal_name)}
                    onPress={() => {
                      dispatch(setCurrentClass(item));
                      navigate('/club/ClassesCover');
                    }}
                    {...item}
                  />
                ))
              }
            </List>
          </>
        )}
    </Container>
  );
}

export default ClassesList;
